import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import MFAGate from "@/components/MFAGate";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!user || !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return <MFAGate>{children}</MFAGate>;
};

export default ProtectedRoute;
